export default {"src":"/_next/static/media/compare-plan.94220db0.svg","height":48,"width":48};